import { render, staticRenderFns } from "./Navigator.vue?vue&type=template&id=06f5a19c&"
import script from "./Navigator.js?vue&type=script&lang=js&"
export * from "./Navigator.js?vue&type=script&lang=js&"
import style0 from "./Navigator.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports